<template>
  <div class="legalagreementcontent">
    <b-modal v-model="showModel" size="lg" id="mainclass" modal-cancel no-close-on-backdrop scrollable hide-header-close >
        <div class="legalagreementcontentclass" v-on:scroll="onScroll" v-html="legalAgreementContent"></div>
      <template #modal-footer>
        <div class="w-100">
          <input id="checkbox" type="checkbox" :value="checkboxVal" :checked="booleanValue"  @click="check($event)" v-on:input="checkboxVal = $event.target.value"/> I accept the above agreement
          <button type="submit" id="i-accept" class="btn btn-md btn-primary" :disabled="!isUserScrolledToBottom" @click="iaccept" style="float: right;"> I Accept</button>
        </div>
      </template>
      <template #modal-header>
        <div class="w-100">
          <h5 class="modal-title" style="font-weight: bold; text-align: center;">Legal Agreement
            <br><small>Please read till the bottom of the Legal Agreement to activate the accept button</small>
          </h5>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "legalagreementpopup",

  props:['legalAgreementContent'],
  data() {
    return {
      showModel:true,
      checkboxVal: false,
      booleanValue: false,
      color: "",
      isUserScrolledToBottom: this.legalAgreementContent.length < 500 ? true:  false

    }
  },

  methods: {
    check: function(e) {
      if (e.target.checked) {
          this.booleanValue = true
          this.color = "#658dbd"

        }else{
          this.booleanValue = false
          this.color = "#f0f0f0"
        }

    },
    iaccept: function(){
      if (this.isUserScrolledToBottom) {
        if (this.booleanValue) {
          this.$bvModal.hide("mainclass")
          this.$parent.saveLegalAgreement()
        }else{
          this.$toastr.Add({
              name: "", // this is give you ability to use removeByName method
              msg: "Please accept the agreement", // Toast Message
              type: "info", // Toast type,
              position: "toast-top-full-width",
              clickClose: true, // Click Close Disable
              timeout: 0,
              showCloseButton: true,
            });
        }
      }
      // else {
      //   this.$toastr.Add({
      //         name: "", // this is give you ability to use removeByName method
      //         msg: "Please read the full agreement", // Toast Message
      //         type: "info", // Toast type,
      //         position: "toast-top-full-width",
      //         clickClose: true, // Click Close Disable
      //         timeout: 0,
      //         showCloseButton: true,
      //       });
      // }
    },

    onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.$toastr.removeByType('info')
        this.isUserScrolledToBottom = true
      }
      else {
        this.isUserScrolledToBottom = false
      }
    }
}
}
</script>



// WEBPACK FOOTER //
// src/components/legalagreementpopup.vue